import React from "react";
import { useAppSelector } from "..";

const useUserIsPersonel = (): boolean => {
  const userFromStore = useAppSelector((state) => state.userStore.userData);
  return React.useMemo<boolean>(() => {
    if (!userFromStore) return false;
    return userFromStore.usertypeRole === "user";
  }, [userFromStore]);
};

export default useUserIsPersonel;
